export function stripHtml(str = "") {
  return (
    str?.replace(/<\/?[^>]+(>|$)/g, "") || str?.replace(/<[^>]*>?/gm, "") || str
  )
}
